/**
 * FSP's go-to blanks. Shown as a chip row above the Style combobox when
 * the user hasn't typed or picked anything yet. One click fills the
 * `style` field with the canonical `BrandName StyleName` string that
 * the `/quote/screen-print` + `/garments/by-style` endpoints expect.
 *
 * Owner-curated list (see QuoteCalcV16 reference). Edit here when the
 * shop's go-to blanks change — no schema / API / backend changes
 * needed.
 */
export type QuickPick = {
  /** Short code shown on the chip (what staff recognise). */
  label: string;
  /** Fabric type — shown as a muted subtitle under the label. */
  subtitle: string;
  /** `BrandName StyleName` string sent to the quote + color-list APIs. */
  style: string;
};

export const QUICK_PICKS: QuickPick[] = [
  { label: 'G5000', subtitle: '100% Cotton', style: 'Gildan 5000' },
  { label: 'G8000', subtitle: 'Dry-Blend', style: 'Gildan 8000' },
  { label: 'Tultex 602', subtitle: '100% Cotton', style: 'Tultex 602' },
  { label: 'NL3600', subtitle: 'Ring Spun', style: 'Next Level 3600' },
  { label: 'G64000', subtitle: 'Ring Spun', style: 'Gildan 64000' },
  { label: 'BC3001', subtitle: 'Ring Spun', style: 'Bella+Canvas 3001' },
  { label: 'TT11', subtitle: 'Dry-Fit', style: 'Team 365 TT11' },
  { label: 'G18500', subtitle: 'Hoodie', style: 'Gildan 18500' },
  { label: 'Tultex 320', subtitle: 'Hoodie', style: 'Tultex 320' },
];
